import React from 'react';
import PropTypes from 'prop-types';
import { ChevronsDown, ChevronsUp } from 'react-feather';

const ColumnHead = ({ column: { key }, sortKey, sortOrderIsAscending, children }) => {
  let sortIcon = <ChevronsDown />;
  if (sortKey === key) {
    sortIcon = sortOrderIsAscending ? <ChevronsDown color="black" /> : <ChevronsUp color="black" />;
  }

  return (
    <>
      {children}
      {sortIcon}
    </>
  );
};

ColumnHead.propTypes = {
  sortKey: PropTypes.string,
  sortOrderIsAscending: PropTypes.bool,
  column: PropTypes.shape({
    key: PropTypes.string.isRequired,
    format: PropTypes.func,
    compare: PropTypes.func
  }).isRequired,
  children: PropTypes.node
};

export default ColumnHead;
